import { useTranslation } from "react-i18next";
import { Button, Form, Icon, Input } from "semantic-ui-react";

import type { AddInterventionAndAppendPinPayloads } from "components";
import type { Dispatch, SetStateAction } from "react";

type RenderInterventionsProps = {
  interventionsAndPins: AddInterventionAndAppendPinPayloads[];
  setInterventionsAndPins: Dispatch<SetStateAction<AddInterventionAndAppendPinPayloads[]>>;
};

export const RenderInterventions = ({ interventionsAndPins, setInterventionsAndPins }: RenderInterventionsProps) => {
  const { t } = useTranslation();

  const handleDeleteIntervention = (offset: number) => setInterventionsAndPins(prev => prev.filter((_, index) => index !== offset));

  const toggleInterventionCustomerOk = (offset: number) => {
    setInterventionsAndPins(prev =>
      prev.map((ip, index) => (index === offset ? { intervention: { ...ip.intervention, customer_ok: !ip.intervention.customer_ok }, pin: ip.pin } : ip))
    );
  };

  const updateInterventionData = (offset: number, data: { title?: string; description?: string }) => {
    setInterventionsAndPins(prev => prev.map((ip, index) => (index === offset ? { intervention: { ...ip.intervention, ...data }, pin: ip.pin } : ip)));
  };

  if (!interventionsAndPins.length) return null;

  return interventionsAndPins.map((interventionsAndPin, index) => (
    <Form.Group className="NewAppointment__CarDetails" key={index}>
      <Form.Field width={8}>
        <label>{t("v8_intervention", "Intervention")}</label>
        <Input
          placeholder={t("v8_intervention", "Intervention")}
          fluid
          value={interventionsAndPin.intervention.title}
          onChange={e => updateInterventionData(index, { title: e.target.value })}
        />
      </Form.Field>

      <Form.Field width={8}>
        <label>{t("v8_remark", "Remark")}</label>
        <Input
          placeholder={t("v8_remark", "Remark")}
          fluid
          value={interventionsAndPin.intervention.description}
          onChange={e => updateInterventionData(index, { description: e.target.value })}
        />
      </Form.Field>

      <Form.Field width={1} className="mt-25 intervention-actions">
        <Button onClick={() => toggleInterventionCustomerOk(index)} type="button" className="wdLightGrey centerIcon greyBorder customer">
          <Icon className={`user check ${interventionsAndPin.intervention.customer_ok ? "green" : "red"}`} />
        </Button>
      </Form.Field>

      <Form.Field width={1} className="mt-25 intervention-actions">
        <Button onClick={() => handleDeleteIntervention(index)} type="button" className="wdLightGrey centerIcon greyBorder customer">
          <Icon className={`trash red`} />
        </Button>
      </Form.Field>
    </Form.Group>
  ));
};
